var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("We're sorry")]),_c('p',[_vm._v(" That page doesn't exist. ")])])
}]

export { render, staticRenderFns }